import Table from 'components/ui/Table/Table';
import { useMemo } from 'react';
import { Column } from 'react-table';
import { Order, OrderItem } from 'types/order';
import { convertToHUF } from 'utils/helpers';

interface IProps {
  orderData: Order;
}

const OrdersTable = ({ orderData }: IProps) => {
  const RIGHT_ALIGN = ['price', 'itemTotal', 'quantity'];
  const columns = useMemo<Column<OrderItem>[]>(
    () => [
      {
        accessor: 'name',
        Header: 'Megnevezés',
        Cell: ({ value }) => (
          <div style={{ width: '100%', whiteSpace: 'normal' }}>{value}</div>
        )
      },
      {
        accessor: 'quantity',
        Header: 'Mennyiség',
        Cell: ({ row }) => (
          <div>
            {row.original.quantity} {row.original.unit}
          </div>
        )
      },
      {
        accessor: 'price',
        Header: 'Egységár',
        Cell: ({ value }) => <span>{convertToHUF(value)}</span>
      },
      {
        accessor: 'itemTotal',
        Header: 'Összesen',
        Cell: ({ value }) => <span>{convertToHUF(value)}</span>
      }
    ],
    []
  );
  return (
    <>
      <h3 className="text-xl font-semibold mb-4">Megrendelt tételek</h3>
      {window.innerWidth >= 1024 ? (
        <Table<OrderItem & { total?: never }>
          columns={columns}
          data={orderData.items}
          isLoading={false}
          getHeaderProps={(headerProps) => ({
            className: RIGHT_ALIGN.includes(headerProps.id) ? 'text-right' : ''
          })}
          getCellProps={(cellProps) => ({
            className: RIGHT_ALIGN.includes(cellProps.column.id) ? 'text-right' : ''
          })}
        />
      ) : (
        <table className="w-full min-w-md max-w-full text-base">
          <thead>
            <tr>
              <th colSpan={3} className="text-left w-full">
                {columns[0].Header?.toString()}
              </th>
            </tr>
            <tr>
              <th className="text-right w-max">{columns[1].Header?.toString()}</th>
              <th className="text-right w-max">{columns[2].Header?.toString()}</th>
              <th className="text-right w-max">{columns[3].Header?.toString()}</th>
            </tr>
          </thead>
          {orderData.items.map((item) => (
            <tbody key={item.id}>
              <tr>
                <td colSpan={3}>{item.name}</td>
              </tr>
              <tr>
                <td className="text-right">{item.quantity} db</td>
                <td className="text-right pl-3">{convertToHUF(item.price)}</td>
                <td className="text-right pl-3">{convertToHUF(item.itemTotal)}</td>
              </tr>
            </tbody>
          ))}
        </table>
      )}
    </>
  );
};

export default OrdersTable;
